import { FaAngleDown } from "react-icons/fa";
import InfoCard from "../../../components/InfoCard";
import { useEffect, useState } from "react";
import attendanceApis from "../../../api/attendanceApis";
import { useParams } from "react-router-dom";

const MONTHS = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER",
];

export default function Attendance() {
  const { classId } = useParams();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = MONTHS[currentDate.getMonth()];

  const [year] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [isOpen, setIsOpen] = useState(false);

  const [stats, setStats] = useState({
    totalDays: 0,
    presentDays: 0,
    absentDays: 0,
  });

  useEffect(() => {
    if (!classId) return;

    const fetchStats = async () => {
      const res = await attendanceApis.getStudentPresentStat(
        Number(classId),
        year,
        month,
      );

      if (res?.status === 1 && res.data) {
        setStats(res.data);
      }
    };

    fetchStats();
  }, [classId, year, month]);

  return (
    <section className="max-w-4xl 2xl:max-w-7xl py-10 mx-auto px-4 flex flex-col gap-14">
      <dl className="grid gap-6">
        <div className="grid grid-cols-[170px_auto] items-center">
          <dt className="text-neutral-400 text-sm font-semibold">
            Academic Year
          </dt>
          <dd className="text-success-700 text-sm font-semibold">
            {year}-{Number(year) + 1}
          </dd>
        </div>

        {/* <div className="grid grid-cols-[170px_auto] items-center">
          <dt className="text-neutral-400 text-sm font-semibold">
            Academic Cycle
          </dt>
          <dd className="text-success-700 text-sm font-semibold">
            Nursery
          </dd>
        </div> */}

        <div className="grid grid-cols-[170px_auto] items-center relative">
          <dt className="text-neutral-400 text-sm font-semibold">Month</dt>

          <div className="relative w-fit">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="flex items-center gap-2 text-success-700 text-sm font-semibold py-2 rounded-md"
            >
              {month}
              <FaAngleDown size={14} />
            </button>

            {isOpen && (
              <ul className="absolute mt-2 bg-white border rounded-md shadow-md z-10 w-40 max-h-60 overflow-y-auto">
                {MONTHS.map((m) => (
                  <li
                    key={m}
                    onClick={() => {
                      setMonth(m);
                      setIsOpen(false);
                    }}
                    className={`px-3 py-2 cursor-pointer hover:bg-primary-50 ${
                      month === m ? "bg-primary-100 font-semibold" : ""
                    }`}
                  >
                    {m}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </dl>

      <div className="grid sm:grid-cols-2 gap-5 md:gap-24">
        <InfoCard label="Total Present" value={stats.presentDays} />
        <InfoCard
          label="Total Absent"
          value={stats.absentDays}
          bgColor="bg-error-50"
          textColor="text-error-700"
        />
      </div>
    </section>
  );
}
